import { Grid, Typography } from '@mui/material';
import { GroupHeader } from 'components';
import { useContext } from 'react';
import { employeeContext } from '../EmployeeContext';
import { applicationContext } from 'helpers/services';


let Address = () => {
    let service = useContext(employeeContext);
    let { isDesktop } = useContext(applicationContext);

    return (
        <Grid container sx={{ marginTop: 1 }}>
            <Grid item xs={12}>
                <GroupHeader title='Address' />
            </Grid>
            {isDesktop &&
                <Grid item xs={12}>
                    <Grid container sx={{ paddingLeft: 4 }}>
                        <Grid item xs={4} md={2}>
                            <Typography>Street</Typography>
                        </Grid>
                        <Grid item xs={8} md={10}>
                            <Typography>{service.employee.street}</Typography>
                        </Grid>
                        <Grid item xs={4} md={2}>
                            <Typography>Postal code</Typography>
                        </Grid>
                        <Grid item xs={8} md={10}>
                            <Typography>{service.employee.postalCode}</Typography>
                        </Grid>
                        <Grid item xs={4} md={2}>
                            <Typography>City</Typography>
                        </Grid>
                        <Grid item xs={8} md={10}>
                            <Typography>{service.employee.city}</Typography>
                        </Grid>
                        <Grid item xs={4} md={2}>
                            <Typography>Country</Typography>
                        </Grid>
                        <Grid item xs={8} md={10}>
                            <Typography>{service.employee.country}</Typography>
                        </Grid>
                        <Grid item xs={4} md={2}>
                            <Typography>Province</Typography>
                        </Grid>
                        <Grid item xs={8} md={10}>
                            <Typography>{service.employee.province}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            }
            {isDesktop === false &&
                <Grid item xs={12}>
                    <Grid container sx={{ paddingLeft: 4 }}>
                        <Grid item xs={12}>
                            <Typography>{service.employee.street}</Typography>
                            <Typography variant='body2'>Street</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>{service.employee.postalCode}</Typography>
                            <Typography variant='body2'>Postal code</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>{service.employee.city}</Typography>
                            <Typography variant='body2'>City</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>{service.employee.country}</Typography>
                            <Typography variant='body2'>Country</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>{service.employee.province}</Typography>
                            <Typography variant='body2'>Province</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    );
}

export default Address;